import type { VirtualAccount } from 'models/virtualAccount';

export const randomElement = (array: Readonly<any[]>) =>
  array[Math.floor(Math.random() * array.length)];

export const randomArbitrary = (min: number, max: number) =>
  Math.round((Math.random() * (max - min) + min + Number.EPSILON) * 100) / 100;

export const virtualAccountLabel = (accountInfo: VirtualAccount) =>
  accountInfo.name ? accountInfo.name : `${accountInfo.currency_name} account`;
